<template>
	<div>
		<div class="">
			<div class="p_m_t_30">

				<div class="p_m_b_20" v-for="(item,index) in data.list" :key="index">
					<p  class="type_size_20" style="line-height:1">
						{{index+1}}.<!-- ({{item.question.year}}) -->
						<el-tag type="success" size="small " effect="dark">{{getQuestionType(item.question.question_type)}}</el-tag>
					</p>
					<div class="type_size_22">
						<span v-html="item.question.title"></span>
					</div>
					<div class="p_flex p_m_t_20 type_size_18">
						<div v-if="item.question.question_type == 1 || item.question.question_type == 2 || item.question.question_type == 5">

							<div class="revised" v-if="item.revised_content">订正：
								{{item.revised_content }}
							</div>
							<div class="proposal" v-if="item.proposal">建议：{{item.proposal}}</div>
							<div class="wrong-answer">回答错误：
								{{item.content}}
							</div>

						</div>

						<div v-else-if="item.question.question_type == 3">

							<div class="revised" v-if="item.revised_content">订正：
								{{item.revised_content == 'A' ? '对' : '错' }}
							</div>
							<div class="proposal" v-if="item.proposal">建议：{{item.proposal}}</div>
							<div class="wrong-answer">回答错误：
								{{item.content == 'A' ? '对' : '错' }}
							</div>

						</div>

						<div v-else-if="item.question.question_type == 4">

							<div class="revised" v-if="item.revised_content">订正：
								<span v-for="(val,key) in item.revised_content" :key="key">{{val.text}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
							</div>
							<div class="proposal" v-if="item.proposal">建议：{{item.proposal}}</div>
							<div class="wrong-answer">回答错误：
								<span v-for="(val,key) in item.content" :key="key">{{val.text}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
							</div>


						</div>

						<div v-else-if="item.question.question_type == 6">
							<div v-for="(val,key) in item.content" :key="key" style="padding-left: 10px; margin: 10px 0;">

								<span v-html="val.name" style="margin-top: 15px;"></span>
								<div class="revised" v-if="item.revised_content">订正：{{item.revised_content[key].text}}</div>
								<div class="proposal" v-if="item.proposal">建议：{{item.proposal}}</div>
								<div class="wrong-answer">回答错误：{{val.text}}</div>
							</div>
						</div>

					</div>
					<div style="margin-top: 10px;" v-if="item.image && item.image.length > 0">
						<div v-if="item.answer_format == 'text'">
							<el-image style="width: 100px; height: 100px" v-for="(val,key) in item.image" :key="key" :src="val"  :preview-src-list="item.image"> </el-image>
						</div>
						<div v-else>
							<p >
								<el-image  style="width: 100px; height: 100px" v-for="(v,k) in item.image" :key="k" :src="v"  :preview-src-list="item.image"> </el-image>
							</p>
						</div>

					</div>

					<div style="margin: 15px 0;" v-if="item.question.analysis">
						解析：{{item.question.analysis}}
					</div>

					<div class="p_flex p_f_e p_f_a p_m_t_20">
						<span class="p_flex  type_size_22 p_m_r_10" v-if="item.result == 1">正确</span>
						<span class="p_flex  type_size_22 p_m_r_10" style="color: #F1282E;" v-if="item.wrong_correct_status == 3">待订正</span>
						<span class="p_flex  type_size_22 p_m_r_10" style="color: #FBB13C;" v-if="item.wrong_correct_status != 3">已订正</span>
						<el-button type="warning" size='mini'  @click='putQuestionTeacherOpen(item)'>提出问题</el-button>
						<div class="p_m_l_10"  v-if="item.job_type == 2">
							<el-button type="success" size='mini' @click='answerSheet(item)'   v-if="item.wrong_correct_status == 3" >去订正</el-button>
						</div>
						<div class="p_m_l_10" v-else>
							<el-button type="success" size='mini'  @click='toRevise(item)' v-if="item.wrong_correct_status == 3" >去订正</el-button>
						</div>

					</div>
				</div>

			</div>

		</div>

		<el-dialog title="提出问题" center :visible="show" @close="close">
			<div class="header_center p_flex p_f_a ">
				<span class="p_m_l_20 type_size_18">选择老师</span>
				<div class="p_f_1 p_m_l_20 p_m_r_20">
					<el-select v-model="putQuestionTeacher.teacher_id" placeholder="请选择" >
						<el-option v-for="(item,index) in teacherList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
			</div>
			<div class=" p_flex p_f_a p_m_t_30 ">
				<div class="p_f_1 ">
					<el-input type="textarea" :autosize="{ minRows: 4}" v-model="putQuestionTeacher.student_content" placeholder="请输入内容"></el-input>
				</div>
			</div>
			<div class="p_flex p_f_c p_m_t_30">
				<el-button type="success" @click="putQuestionTeacherSubmit" >确认</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				postData:{ job_submit_id:null, wrong_correct_status:3 },
				data: { count:0, list:[] },
				questionTypeList: [],
				show: false,
				putQuestionTeacher: { teacher_id:null, type:1, job_publish_id:null, title:null, student_content:null, question_id:null },
				teacherList: [],
			};
		},
		mounted() {
			this.postData.job_submit_id = this.$route.query.jobSubmitId
			this.postData.wrong_correct_status = this.$route.query.status
			this.getQuestionTypeList()
			this.getTeacherList()
			this.getList()

		},
		methods:{

			getList(){
				this.$request.ajax(this).post('api_student/wrong_question_list',this.postData).then(res=>{
					this.data = res.data
				})
			},

			putQuestionTeacherSubmit(){
				var param = this.putQuestionTeacher
				if( !param.teacher_id ) return this.$message('请选择提问老师')
				if( !param.student_content ) return this.$message('请输入提问内容')
				this.$request.ajax(this).post('api_student/put_question_teacher', param).then(res=>{
					this.close()
				})
			},

			putQuestionTeacherOpen(e){
				this.putQuestionTeacher.title = e.question.title
				this.putQuestionTeacher.job_publish_id = e.job_publish_id
				this.putQuestionTeacher.question_id = e.question_id
				this.putQuestionTeacher.subject = e.subject
				this.show = true
			},

			getTeacherList(){
				this.$request.ajax(this).post('api_student/put_question_choice_teacher').then(res=>{
					this.teacherList = res.data
				})
			},

			getQuestionType(id){
				if( !this.questionTypeList) {
					this.getQuestionTypeList()
				}
				for( let i=0; i<this.questionTypeList.length; i++ ){
					if( id == this.questionTypeList[i].id ){
						return this.questionTypeList[i].name
					}
				}
			},

			getQuestionTypeList(){
				this.$request.ajax(this).post('Library/questionType').then(res=>{
					this.questionTypeList = res.data
				})
			},

			close(){
				this.putQuestionTeacher = { teacher_id:null, type:1, job_publish_id:null, title:null, student_content:null, question_id:null }
				this.show = false
			},

			goCorrect(){
				this.$emit('goCorrect', {
					show:true
				});
			},

			// 去订正
			toRevise(e){
				this.$router.push({
					path:'/Correcte',
					query:{
						id: e.id,
						status: this.$route.query.status
					}
				})
			},
			answerSheet(e){
				this.$router.push({
					path:'/MistakesSheet',
					query:{
						id: e.id,
						status: this.$route.query.status
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
.deatil_header {
	padding: 30px 0;
}
>>> .el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
.deatil_img {
	width: 300px;
	height: 450px;
}

.wrong-answer{
	padding-left: 10px;
	margin: 15px;
	font-size: 16px;
	color: #999999;
}

.proposal{
	color: #FF9C00;
	padding: 20px;
	background-color: #FFFAF2 ;
	border-radius: 20px;
	margin: 15px;
	font-size: 16px;
	padding-left: 10px;
}
.revised{
	color: #00AF63;
	font-size: 16px;
	margin: 25px 15px 15px 15px;
	padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/errors/components/correct.vue